import { atom, useAtom, useSetAtom } from 'jotai';

import type { IOModal } from '../types/insertionOrder.js';
import { useSetInsertionOrderLoading } from './useInsertionOrderLoading.js';

export const insertionOrderModal = atom<IOModal>({
  isOpen: false,
  type: 'default',
  data: null,
});

export const useInsertionOrderModal = () => {
  const [modalData, setModalData] = useAtom(insertionOrderModal);
  const setIsInsertionOrderLoading = useSetInsertionOrderLoading();

  const closeModal = () => {
    setModalData({ isOpen: false, type: 'default', data: null });
    setIsInsertionOrderLoading(false);
  };

  return { modalData, setModalData, closeModal };
};

export const useSetInsertionOrderModalData = () => {
  const setModalData = useSetAtom(insertionOrderModal);

  return setModalData;
};
